<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="htitle">
<svg height="95%" preserveaspectratio="xMidYMid meet" version="1.1" viewbox="0 0 600 900" width="95%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<image height="900" width="600" xlink:href="ppp-clubbeddeath-cover.jpg"></image>
</svg>
<br/><br/><p class="bkht">Clubbed to Death</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pppclubbeddeath001.vue?71a96fd3